import React from 'react';
import LoadingMask from '../../../../../CommonComponents/LoadingMask';
import { formatNumberLegacy } from '../../../../../CommonUtils/formatNumberLegacy';
import { AssetClass, Correlations } from '../../types';
import { Matrix } from './styles';

interface CorrelationMatrixProps {
  assetClassesIndexedById: Record<number, AssetClass>;
  correlations: Correlations;
}

export const LoadingCorrelationMatrix: React.FC = () => <LoadingMask isDark height="766px" />;

export const CorrelationMatrix: React.FC<CorrelationMatrixProps> = ({
  assetClassesIndexedById,
  correlations,
}) => (
  <Matrix>
    <thead>
      <tr>
        <th aria-label="Empty Header" />
        {Object.keys(correlations).map(id => (
          <th key={id}>
            <div>{assetClassesIndexedById[id].customName}</div>
          </th>
        ))}
      </tr>
    </thead>

    <tbody>
      {Object.entries(correlations).map(([rowAssetClassId, rowAssetClassCorrelations]) => (
        <tr key={rowAssetClassId}>
          <td>{assetClassesIndexedById[rowAssetClassId].customName}</td>

          {Object.entries(rowAssetClassCorrelations).map(
            ([colAssetClassId, colAssetClassCorrelation]) => (
              <td key={`${rowAssetClassId}-${colAssetClassId}`}>
                {formatNumberLegacy(colAssetClassCorrelation, { maxDecimalPlaces: 2 })}
              </td>
            ),
          )}
        </tr>
      ))}
    </tbody>
  </Matrix>
);
